/**
 * @param {number} width Width of rectangle relative to which center we gonna calculate angle.
 * @param {number} height Height of rectangle.
 * @param {number} targetX Coordinates relative to rectangle left border.
 * @param {number} targetY Coordinates relative to rectangle top border.
 * @returns {number} Angle in radians between top center pointer of rectangle, rectangle center and point represented by targetX and targetY params.
 */

export const getAngle = ({width, height, targetX, targetY}) => {
  const {pow, sqrt, acos, PI} = Math;

  // Coordinates of square center
  const centerX = width / 2;
  const centerY = height / 2;

  // Coordinates of progress bar beginning
  const startX = centerX;
  const startY = centerY - height / 2;

  const p12 = sqrt(pow(centerX - startX, 2) + pow(centerY - startY, 2));
  const p13 = sqrt(pow(centerX - targetX, 2) + pow(centerY - targetY, 2));
  const p23 = sqrt(pow(startX - targetX, 2) + pow(startY - targetY, 2));

  if ([p12, p13, p23].indexOf(0) !== -1) {
    return 0;
  }

  let angle = acos((pow(p12, 2) + pow(p13, 2) - pow(p23, 2)) / (2 * p12 * p13)) / PI;

  if (targetX < centerX) {
    angle = 2 - angle;
  }

  return angle;
};
